export default function percent(num) {
  return parseFloat(num).toFixed(1) + '%'
}
